<template>
  <div class="app-container">
    <!-- 头部信息： 左侧设备信息 + 右侧格口满袋消息通知 -->
    <el-row :gutter="20" class="header-row">
      <el-col :span="14">
        <el-card class="box-card machine-card">
          <div slot="header" class="clearfix">
            <span>{{ $t('CenterForSorting.currentDevice') }}</span>
            <span class="machine-select-wrap">
              <el-select
                v-model="machineId"
                :placeholder="$t('CenterForSorting.pleaseChoose')"
                filterable
                size="small"
                style="width: 280px"
                @change="handleMachineChange"
              >
                <el-option
                  v-for="item in machineList"
                  :key="item.id"
                  :label="item.machineName"
                  :value="String(item.id)"
                />
              </el-select>
            </span>
            <div style="float: right">
              <el-tag style="margin-right: 10px" type="success">
                {{ $t('CenterForSorting.open') }}: {{ openChuteCount }}
              </el-tag>
              <el-tag style="margin-right: 10px" type="info">{{ $t('CenterForSorting.close') }}:
                {{ machineInfo.closedChuteCount }}
              </el-tag>
              <el-tag style="margin-right: 10px" type="warning">{{ $t('CenterForSorting.fullBag') }}:
                {{ machineInfo.fullBagCount }}
              </el-tag>
              <!--          <el-button type="text" @click="handleGoBack">{{ $t('CenterForSorting.backToList') }}-->
              <!--          </el-button>-->
            </div>
          </div>
          <el-descriptions
            :column="3" border direction="vertical"
            size="small"
          >
            <el-descriptions-item :label="$t('CenterForSorting.machineName')">{{ machineInfo.machineName }}
            </el-descriptions-item>
            <el-descriptions-item :label="$t('CenterForSorting.machineCode')">{{ machineInfo.machineCode }}
            </el-descriptions-item>
            <el-descriptions-item :label="$t('CenterForSorting.totalChutes')">{{ machineInfo.chuteCount }}
            </el-descriptions-item>
          </el-descriptions>
        </el-card>
      </el-col>
      <el-col :span="10">
        <el-card class="box-card notice-card">
          <div slot="header" class="clearfix">
            <i class="el-icon-bell notice-icon" />
            <span class="notice-title">{{ $t('CenterForSorting.fullBagNotice') }}</span>
            <el-tag :type="noticeTotal ? 'warning' : 'info'" size="mini" style="float: right">{{ noticeTotal }}
            </el-tag>
          </div>
          <div v-if="noticeList.length" class="notice-list">
            <div class="notice-items">
              <div
                v-for="(item, index) in noticeList"
                :key="`${getNoticeKey(item)}_${index}`"
                :title="$t('CenterForSorting.fullBagNoticeTip')"
                class="notice-item"
                @click="handleNoticeClick(item)"
              >
                <span :class="item.recoverTime ? 'dot-recovered' : 'dot-full'" class="notice-dot" />
                <div class="notice-text">
                  <span class="notice-chute-no">{{ item.chuteNumber }}：</span>
                  <span>{{ item.fullBagText || $t('CenterForSorting.fullBag') }}，{{
                    item.fullBagTime
                  }}</span>
                  <span v-if="item.recoverTime" class="notice-recover">
                    {{ item.recoverText || $t('CenterForSorting.recoverNormal') }}，{{
                      item.recoverTime
                    }}
                  </span>
                </div>
              </div>
            </div>
            <!-- 触底提示：还有数据时可点击加载下一页，全部加载完则显示没有更多 -->
            <div v-if="hasMoreNotice" class="notice-more" @click="loadMoreNotice">
              <i v-if="noticeLoadingMore" class="el-icon-loading" />
              <template v-else>
                <i class="el-icon-arrow-down" />
                {{ $t('CenterForSorting.clickLoadMore') }}
              </template>
            </div>
            <div v-else class="notice-more is-end">{{ $t('CenterForSorting.noMoreData') }}</div>
          </div>
          <div v-else class="notice-empty">
            <i class="el-icon-bell" />
            <p>{{ $t('CenterForSorting.noFullBagNotice') }}</p>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 工 具栏 -->
    <div
      class="filter-container sticky-toolbar"
      style="
        margin-bottom: 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
      "
    >
      <div>
        <el-button
          icon="el-icon-refresh" size="small" type="primary"
          @click="fetchData"
        >{{ $t('CenterForSorting.refresh') }}
        </el-button>
        <el-select
          v-model="autoRefresh"
          :placeholder="$t('CenterForSorting.autoRefresh')"
          size="small"
          style="width: 120px; margin: 0 10px"
          @change="handleAutoRefresh"
        >
          <el-option :label="$t('CenterForSorting.closeAutoRefresh')" :value="0" />
          <el-option :label="$t('CenterForSorting.refresh30s')" :value="30" />
          <el-option :label="$t('CenterForSorting.refresh60s')" :value="60" />
        </el-select>
        <!--导出格口数据-->
        <el-button size="small" type="primary" @click="allExportOrder">{{ $t('tablePrice.exportCompartmentData') }}
        </el-button>
        <!-- 清理格口 -->
        <el-button
          v-permit:remove="'btn:sortingManagementNew:chuteView:clearGridCell'"
          size="small"
          type="primary"
          @click="clearGridCell"
        >{{ $t('changepwd.clearCompartment') }}
        </el-button>
        <!-- 关闭所有格口 -->
        <el-button
          v-permit:remove="'btn:sortingManagementNew:chuteView:closeGridCell'"
          size="small"
          @click="closeGridCell"
        >{{ $t('changepwd.closeAllCompartment') }}
        </el-button>
      </div>
      <div class="legend">
        <span class="legend-item"><span class="color-box status-1" />{{ $t('CenterForSorting.open') }}</span>
        <span class="legend-item"><span class="color-box status-0" />{{ $t('CenterForSorting.close') }}</span>
        <span class="legend-item"><span class="color-box status-2" />{{ $t('CenterForSorting.fullBag') }}</span>
      </div>
    </div>

    <!-- 格口网格 -->
    <div v-loading="loading" class="chute-grid">
      <div
        v-for="chute in chuteList"
        :key="chute.chuteNumber"
        :ref="'chuteCard_' + chute.chuteNumber"
        :class="'status-' + chute.chuteStatus"
        class="chute-card"
      >
        <div class="chute-header">
          <span class="chute-number">{{ chute.chuteNumber }}</span>
          <el-tag :type="getStatusType(chute.chuteStatus)" size="mini">{{ getStatusText(chute.chuteStatus) }}
          </el-tag>
        </div>
        <div class="chute-content">
          <div :title="chute.ruleName" class="rule-name">
            <span class="rule-name-text">{{
              chute.ruleName || $t('CenterForSorting.noRule')
            }}</span>
            <i
              v-if="chute.ruleName"
              class="el-icon-tickets"
              style="cursor: pointer; color: #00a551; margin-left: 5px; flex-shrink: 0"
              @click.stop="handleRuleDetail(chute)"
            />
          </div>
          <div :class="{ 'bag-count-highlight': Number(chute.bagCount) > 0 }" class="bag-count">
            {{ $t('CenterForSorting.bagCount') }}: {{ chute.bagCount }}
          </div>
        </div>
        <div v-permit:remove="'btn:sorting:chuteView:operation'" class="chute-actions">
          <el-dropdown trigger="click" @command="(cmd) => handleCommand(cmd, chute)">
            <span class="el-dropdown-link" @click.stop>
              {{ $t('CenterForSorting.operation') }}<i class="el-icon-arrow-down el-icon--right" />
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :disabled="chute.chuteStatus === 1" command="open">{{ $t('CenterForSorting.open') }}
              </el-dropdown-item>
              <el-dropdown-item :disabled="chute.chuteStatus === 0" command="close">{{ $t('CenterForSorting.close') }}
              </el-dropdown-item>
              <el-dropdown-item :disabled="chute.chuteStatus === 2" command="full">{{ $t('CenterForSorting.setFull') }}
              </el-dropdown-item>
              <el-dropdown-item command="clear" divided>{{ $t('CenterForSorting.clearData') }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>

    <!-- 规则信息对话框 -->
    <rule-condition-detail
      :condition-configs="conditionConfigs"
      :rule-id="currentRuleId"
      :visible.sync="viewConditionsVisible"
    />
  </div>
</template>

<script>
import {
  batchClearAllChuteData,
  clearChuteData,
  closeAllChutes,
  exportChuteView,
  getAllMachineList,
  getChuteNoticePage,
  getChuteView,
  updateChuteStatus
} from '@/api/sorting/machine';
import { getConditionConfigList } from '@/api/sorting/rule';
import RuleConditionDetail from './components/RuleConditionDetail';
import { goResourceTaskList } from '@/utils/goExportList';

export default {
  name: 'ChuteView',
  components: { RuleConditionDetail },
  data() {
    return {
      machineId: null,
      machineList: [],
      machineInfo: {
        machineName: '',
        machineCode: '',
        chuteCount: 0,
        closedChuteCount: 0,
        fullBagCount: 0,
        scanNumberRegex: ''
      },
      chuteList: [],
      loading: false,
      autoRefresh: 30,
      timer: null,
      dialogVisible: false,
      currentChute: null,
      viewConditionsVisible: false,
      currentRuleId: null,
      conditionConfigs: [],
      // 满袋消息通知
      noticeList: [],
      noticeTotal: 0,
      noticePageSize: 50,
      noticePageNumber: 1,
      noticeLoadingMore: false
    };
  },
  computed: {
    openChuteCount() {
      return (
        this.machineInfo.chuteCount -
        this.machineInfo.closedChuteCount -
        this.machineInfo.fullBagCount
      );
    },
    // 已加载条数小于总数时，说明还有下一页
    hasMoreNotice() {
      return this.noticeTotal > this.noticeList.length;
    }
  },
  watch: {
    '$route.query.machineId'(newMachineId) {
      // 与当前已选设备一致时无需处理（如本页同步地址栏、选择框切换）
      if (String(newMachineId || '') === String(this.machineId || '')) return;
      this.syncMachineIdFromRoute({ forceReload: true });
    }
  },
  created() {
    this.syncMachineIdFromRoute({ forceReload: true });
    this.fetchConditionConfigs();
  },
  activated() {
    this.syncMachineIdFromRoute();
  },
  deactivated() {
    this.stopTimer();
  },
  beforeDestroy() {
    this.stopTimer();
  },
  methods: {
    isCurrentChuteViewRoute() {
      return (
        this.$route.name === 'ChuteView' ||
        this.$route.path === '/expressDataCenter/sortingManagementNew/chuteView'
      );
    },
    async loadMachineList() {
      if (this.machineList.length) return;
      try {
        const res = await getAllMachineList();
        this.machineList = res.data || [];
      } catch (error) {
        this.machineList = [];
      }
    },
    resetMachineData() {
      this.machineInfo = {
        machineName: '',
        machineCode: '',
        chuteCount: 0,
        closedChuteCount: 0,
        fullBagCount: 0,
        scanNumberRegex: ''
      };
      this.chuteList = [];
      this.noticeList = [];
      this.noticeTotal = 0;
      this.noticePageNumber = 1;
      this.noticeLoadingMore = false;
    },
    async syncMachineIdFromRoute({ forceReload = false } = {}) {
      if (!this.isCurrentChuteViewRoute()) {
        this.stopTimer();
        return;
      }

      // 始终加载设备列表，保证下拉框能显示来源页携带的设备名称
      await this.loadMachineList();

      let routeMachineId = this.$route.query.machineId;
      // 非跳转（直接打开页面）时没有 machineId，默认选中第一台设备
      const isDefault = !routeMachineId;
      if (isDefault) {
        routeMachineId = this.machineList.length ? String(this.machineList[0].id) : '';
      }
      if (!routeMachineId) {
        this.stopTimer();
        this.$message.error(this.$t('CenterForSorting.noDeviceId'));
        return;
      }

      const machineChanged = String(routeMachineId) !== String(this.machineId || '');
      if (machineChanged) {
        this.machineId = String(routeMachineId);
        this.resetMachineData();
      }

      if (machineChanged || forceReload || !this.chuteList.length) {
        this.fetchData();
      }
      this.startTimer();

      // 默认设备同步到地址栏，保证刷新/分享时仍为同一台设备
      if (isDefault) {
        this.$router.replace({ query: { ...this.$route.query, machineId: routeMachineId }});
      }
    },
    handleMachineChange(machineId) {
      if (!machineId) return;
      this.machineId = String(machineId);
      this.resetMachineData();
      this.fetchData();
      this.startTimer();
      this.$router.replace({ query: { ...this.$route.query, machineId: this.machineId }});
    },
    fetchData() {
      if (!this.machineId) return;
      this.loading = true;
      getChuteView({ machineId: this.machineId })
        .then((response) => {
          this.machineInfo = response.data.machineInfo;
          this.chuteList = response.data.chuteList;
        })
        .catch(() => {
          this.stopTimer(); // 出错时停止定时器以防止垃圾请求
        })
        .finally(() => {
          this.loading = false;
        });
      this.fetchNoticeList();
    },
    // 获取设备满袋消息通知列表（按已展开的页数整段拉取，避免定时刷新把"查看更多"的内容收回去）
    fetchNoticeList() {
      if (!this.machineId) return;
      const pageSize = this.noticePageSize * this.noticePageNumber;
      getChuteNoticePage({
        pageNumber: 1,
        pageSize,
        params: { machineId: this.machineId }
      })
        .then((response) => {
          const data = response.data || {};
          const records = data.records || [];
          this.noticeList = records;
          this.noticeTotal = data.total || 0;
          this.noticePageNumber = Math.max(1, Math.ceil(records.length / this.noticePageSize));
        })
        .catch(() => {
          this.noticeList = [];
          this.noticeTotal = 0;
          this.noticePageNumber = 1;
        });
    },
    getNoticeKey(item) {
      return `${item.chuteNumber}_${item.fullBagTime}`;
    },
    // 点击底部"查看更多"，加载下一页并追加到现有列表
    loadMoreNotice() {
      if (this.noticeLoadingMore || !this.hasMoreNotice || !this.machineId) return;
      this.noticeLoadingMore = true;
      const nextPage = this.noticePageNumber + 1;
      getChuteNoticePage({
        pageNumber: nextPage,
        pageSize: this.noticePageSize,
        params: { machineId: this.machineId }
      })
        .then((response) => {
          const data = response.data || {};
          const records = data.records || [];
          const existKeys = new Set(this.noticeList.map((item) => this.getNoticeKey(item)));
          const appendList = records.filter((item) => !existKeys.has(this.getNoticeKey(item)));
          this.noticeList = this.noticeList.concat(appendList);
          this.noticeTotal = data.total || this.noticeTotal;
          this.noticePageNumber = nextPage;
          // 后端返回空页但总数仍偏大时（数据变动导致），避免提示一直存在
          if (!records.length) {
            this.noticeTotal = this.noticeList.length;
          }
        })
        .catch(() => {})
        .finally(() => {
          this.noticeLoadingMore = false;
        });
    },
    handleGoBack() {
      this.$router.push('/expressDataCenter/sortingManagementNew/machineList');
    },
    startTimer() {
      this.stopTimer();
      if (this.autoRefresh > 0) {
        this.timer = setInterval(this.fetchData, this.autoRefresh * 1000);
      }
    },
    stopTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    handleAutoRefresh() {
      this.startTimer();
    },
    getStatusType(status) {
      switch (status) {
        case 1:
          return 'success';
        case 0:
          return 'info';
        case 2:
          return 'warning';
        default:
          return '';
      }
    },
    getStatusText(status) {
      switch (status) {
        case 1:
          return this.$t('CenterForSorting.open');
        case 0:
          return this.$t('CenterForSorting.close');
        case 2:
          return this.$t('CenterForSorting.fullBag');
        default:
          return this.$t('CenterForSorting.unknown');
      }
    },
    handleChuteClick(chute) {
      this.currentChute = chute;
      this.dialogVisible = true;
    },
    // 点击满袋通知定位到对应格口卡片
    handleNoticeClick(chute) {
      const ref = this.$refs[`chuteCard_${chute.chuteNumber}`];
      const el = Array.isArray(ref) ? ref[0] : ref;
      if (el && el.scrollIntoView) {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    },
    async fetchConditionConfigs() {
      const res = await getConditionConfigList();
      this.conditionConfigs = res.data || [];
    },
    handleRuleDetail(chute) {
      if (!chute.ruleId) return;
      this.currentRuleId = chute.ruleId;
      this.viewConditionsVisible = true;
    },
    handleCommand(command, chute) {
      if (command === 'clear') {
        this.$confirm(
          this.$t('CenterForSorting.confirmClearData', { chuteNo: chute.chuteNumber }),
          this.$t('CenterForSorting.tips'),
          {
            type: 'warning',
            confirmButtonText: this.$t('CenterForSorting.sure'),
            cancelButtonText: this.$t('CenterForSorting.cancel')
          }
        ).then(() => {
          clearChuteData({ chuteId: chute.chuteId || chute.id }).then(() => {
            this.$message.success(this.$t('CenterForSorting.clearSuccess'));
            this.fetchData();
          });
        });
      } else {
        let status = 1;
        if (command === 'close') status = 0;
        if (command === 'full') status = 2;

        updateChuteStatus({ chuteId: chute.chuteId || chute.id, status }).then(() => {
          this.$message.success(this.$t('CenterForSorting.statusUpdateSuccess'));
          this.fetchData();
        });
      }
    },
    // 导出
    allExportOrder() {
      exportChuteView(this.machineId).then((res) => {
        if (res.code === 200) {
          goResourceTaskList();
        }
      });
    },
    clearGridCell() {
      this.$confirm(this.$t('CenterForSorting.confirmClearAllData'), this.$t('GlobalSetObj.tips'), {
        type: 'warning',
        confirmButtonText: this.$t('CenterForSorting.sure'),
        cancelButtonText: this.$t('CenterForSorting.cancel'),
        dangerouslyUseHTMLString: true,
        customClass: 'clear-all-confirm'
      })
        .then(() => {
          batchClearAllChuteData(this.machineId).then((res) => {
            if (res.code === 200) {
              this.$message.success(this.$t('CenterForSorting.clearSuccess'));
              this.fetchData();
            }
          });
        })
        .catch(() => {});
    },
    closeGridCell() {
      this.$confirm(
        this.$t('CenterForSorting.confirmCloseAllChutes'),
        this.$t('CenterForSorting.tips'),
        {
          type: 'warning',
          confirmButtonText: this.$t('CenterForSorting.sure'),
          cancelButtonText: this.$t('CenterForSorting.cancel'),
          dangerouslyUseHTMLString: true
        }
      )
        .then(() => {
          closeAllChutes(this.machineId).then((res) => {
            if (res.code === 200) {
              this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
              this.fetchData();
            }
          });
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped>
/* 头部左右布局：左侧设备信息 + 右侧满袋消息通知 */
.header-row {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  margin-bottom: 20px;
}

.header-row > .el-col {
  display: flex;
}

.header-row .box-card {
  width: 100%;
  height: 210px;
  display: flex;
  flex-direction: column;
}

.header-row ::v-deep .el-card__header {
  flex-shrink: 0;
  padding: 12px 20px;
}

.header-row ::v-deep .el-card__body {
  flex: 1;
  min-height: 0;
  padding: 14px 20px;
}

/* 设备信息卡片：内容（如较长的扫描正则）超出时可内部滚动，不撑高卡片 */
.header-row .machine-card ::v-deep .el-card__body {
  overflow-y: auto;
}

/* 满袋通知卡片：卡片体内部再纵向布局，列表区域自适应剩余高度 */
.header-row .notice-card ::v-deep .el-card__body {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.notice-icon {
  color: #e6a23c;
}

.notice-title {
  margin-left: 6px;
  font-weight: 500;
}

.notice-list {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding-right: 4px;
}

.notice-item {
  position: relative;
  padding: 0 0 14px 18px;
  font-size: 12px;
  line-height: 1.6;
  color: #303133;
  cursor: pointer;
  transition: background-color 0.2s;
}

.notice-item:last-child {
  padding-bottom: 2px;
}

/* 时间轴竖虚线 */
.notice-item::before {
  content: '';
  position: absolute;
  top: 13px;
  bottom: -2px;
  left: 4px;
  border-left: 1px dashed #dcdfe6;
}

.notice-item:last-child::before {
  display: none;
}

.notice-item:hover {
  background-color: #fdf6ec;
}

.notice-dot {
  position: absolute;
  top: 6px;
  left: 0;
  width: 9px;
  height: 9px;
  border-radius: 50%;
}

/* 绿点：已恢复正常 */
.dot-recovered {
  background-color: #67c23a;
}

/* 红点：仍为满袋 */
.dot-full {
  background-color: #f56c6c;
}

.notice-text {
  word-break: break-all;
}

.notice-chute-no {
  font-weight: bold;
  color: #303133;
}

.notice-recover {
  margin-left: 8px;
  color: #67c23a;
}

/* 列表底部的"查看更多"提示 */
.notice-more {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 0 2px;
  font-size: 12px;
  color: #909399;
  cursor: pointer;
  user-select: none;
  transition: color 0.2s;
}

.notice-more:hover {
  color: #00a551;
}

.notice-more i {
  margin-right: 3px;
}

.notice-more.is-end {
  color: #c0c4cc;
  cursor: default;
}

.notice-more.is-end:hover {
  color: #c0c4cc;
}

.notice-empty {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #909399;
  font-size: 12px;
}

.notice-empty i {
  margin-bottom: 6px;
  font-size: 22px;
  color: #c0c4cc;
}

.notice-empty p {
  margin: 0;
}

.machine-select-wrap {
  display: inline-flex;
  align-items: center;
  margin-left: 24px;
  vertical-align: middle;
}

.machine-select-label {
  margin-right: 12px;
  font-weight: bold;
}

.sticky-toolbar {
  position: sticky;
  top: -20px;
  z-index: 10;
  background-color: #fff;
  padding: 10px 0;
}

.chute-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 15px;
}

.chute-card {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 10px;
  cursor: pointer;
  transition: all 0.3s;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 140px;
}

.chute-card:hover {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.status-1 {
  background-color: #f0f9eb;
  border-color: #67c23a;
}

.status-0 {
  background-color: #f4f4f5;
  border-color: #909399;
}

.status-2 {
  background-color: #ffdbdb;
  border-color: #bf0000;
}

.chute-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.chute-number {
  font-weight: bold;
  font-size: 18px;
}

.chute-content {
  flex-grow: 1;
}

.rule-name {
  font-size: 12px;
  color: #606266;
  margin-bottom: 5px;
  display: flex;
  align-items: center;
}

.rule-name-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.bag-count {
  font-size: 14px;
  font-weight: bold;
}

.bag-count-highlight {
  color: #ff9900;
}

.chute-actions {
  text-align: right;
  margin-top: 5px;
}

.legend {
  display: flex;
  gap: 15px;
}

.legend-item {
  display: flex;
  align-items: center;
  font-size: 12px;
}

.color-box {
  width: 12px;
  height: 12px;
  margin-right: 5px;
  border: 1px solid #ddd;
}

.color-box.status-1 {
  background-color: #f0f9eb;
  border-color: #67c23a;
}

.color-box.status-0 {
  background-color: #f4f4f5;
  border-color: #909399;
}

.color-box.status-2 {
  background-color: #fdf6ec;
  border-color: #e6a23c;
}
</style>
